import { render, staticRenderFns } from "./cardPay.vue?vue&type=template&id=71fcbb37&"
import script from "./cardPay.vue?vue&type=script&lang=js&"
export * from "./cardPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports